import axios from 'axios';
const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });

export const analyzeCall = async file => {
  const form = new FormData();
  form.append('file', file);
  const { data } = await API.post('/upload-call', form);
  return {
    call_id: data.call_id,
    score: data.score,
    summary: data.summary,
    suggestion: data.suggestion,
    raw: data.raw_feedback,
  };
};

export const requestCallback = async payload => {
  await API.post('/request-callback', payload);
};

export const sendFeedback = async payload => {
  await API.post('/feedback', payload);
};
